import axios from "axios";
const baseUrl = "https://api.shiningstarsfostering.com/";

export const api = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export const baseFunc = (endURL) => {
  return (method, options) => {
    const params = options?.params ? "/" + options.params : "";
    let url = `/${endURL}${params}`;
    if (options?.postfix) {
      url += options.postfix;
    }

    if (method.toLowerCase() === "get") {
      return api.get(url);
    } else if (method.toLowerCase() === "post") {
      return api.post(url, options?.data);
    } else if (method.toLowerCase() === "put") {
      return api.put(url, options?.data);
    } else if (method.toLowerCase() === "delete") {
      return api.delete(url, {
        data: JSON.stringify({ deleted: 1 }),
      });
    }
  };
};
